webpackJsonp([278993523709514],{

/***/ 144:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BannerTitle = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Page = function Page() {
	  return _react2.default.createElement(
	    _react2.default.Fragment,
	    null,
	    _react2.default.createElement(_BannerTitle.SetBannerTitle, { value: "Network Infrastructure Design" }),
	    _react2.default.createElement(
	      'div',
	      { className: 'services-content' },
	      _react2.default.createElement(
	        'section',
	        { className: 'divided-section-content' },
	        _react2.default.createElement(
	          'p',
	          null,
	          'If selected as your design-build contractor, you will have one point of contact from the evolution to the completion of a project. This method not only saves our customers money, it decreases the overall duration of a project to meet challenging deadlines.'
	        ),
	        _react2.default.createElement(
	          'p',
	          null,
	          'Our on-staff BICSI Registered Communications Distribution Designer (RCDD) and industry experts can offer value-engineered advantages to provide cost-savings for any solution. We believe transparency is a vital key to the success of a project and all details will be communicated during its conception.'
	        )
	      )
	    )
	  );
	};
	
	exports.default = Page;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-design-network-infrastructure-js-426b9fb62ec443cf32bf.js